import { useContext, useEffect, useState } from 'react'
import Page from '../layout/Page'
import { useMsal } from '@azure/msal-react'
import { Grid, Typography, Stack, TextField, Button, FormControlLabel, Switch } from '@mui/material'
import RoleContext from '../auth/RoleContext'
import { getAuthenticator, getToken } from '../auth/auth'
import { AzureAdClient } from '../config/config'
import { Stage } from '../config/config'
import FeatureFlagsContext from '../config/FeatureFlagsContext'
import CacheContext from '../cache/CacheContext'
import Cache from '../cache/Cache'

export default function HomePage(props = {}) {
  const featureFlagsContext = useContext(FeatureFlagsContext);
  const roleCtx = useContext(RoleContext)
    const cacheContext = useContext(CacheContext)

  const [account, setAccount] = useState(getAuthenticator().getCurrentAccount())
  const [graphToken, setGraphToken] = useState('')

  const clearCache = () => {
      cacheContext.removeAll()
      Cache.removeAll()
    }

  return (
        <Page {...props}>
          <Grid container spacing={1}>
            <Grid item xs={12}><Typography variant="h4" gutterBottom>NAOU QSE Portal Home</Typography></Grid>
            <Grid item xs={12}><span>Name: {account?.name || 'null'}</span></Grid>
            <Grid item xs={12}><span>Username: {account?.username || 'null'}</span></Grid>
            <Grid item xs={12}><span>Email: {account?.idTokenClaims.mail || 'null'}</span></Grid>
            <Grid item xs={12}><span>Department: {account?.idTokenClaims.department || 'N/A'}</span></Grid>
            <Grid item xs={12}><span>NAOU QSE Portal Role: {roleCtx.role?.name || 'No roles'}</span></Grid>
            {Stage !== 'prod' && <Grid item xs={12}>
              <Stack direction='row'>
                <TextField
                  label='MS Graph Token'
                  value={graphToken}
                  InputLabelProps={{ sx: { background: 'none !important' } }}
                  onFocus={() => setGraphToken('')}
                  onChange={(e) => {
                    const v = e.target.value
                    if (v === '') {
                      window.sessionStorage.removeItem('mockGraphToken')
                    } else {
                      window.sessionStorage.setItem('mockGraphToken', v)
                    }
                    setGraphToken(v)
                  }}
                />
              </Stack>
            </Grid>}
            { Stage === 'prod' && 
              roleCtx.isAdminUser() &&
              <Grid item xs={12}>
              <Button variant='text' onClick={async () => {
                const cachedToken = await getToken(true)
                navigator.clipboard.writeText(cachedToken.accessToken)
                }
              }>Copy Graph Token</Button>
            </Grid>
            }
            {
              (roleCtx.isSafetyManager() || roleCtx.isQualityManager() || roleCtx.isSustainabilityManager()) &&
              ['communityHub'].map(flagName => {
                const flagValue = featureFlagsContext.featureFlags[flagName];
                return (
                  <Grid item xs={12}>
                  <FormControlLabel
                    key={flagName}
                    control={
                      <Switch
                        checked={!!flagValue}
                        onChange={(e) => {
                          clearCache()
                          featureFlagsContext.setFlag(flagName, e.target.checked)
                        }}
                      />
                    }
                    label={flagName}
                  />
                  </Grid>
                );
              })
            }
            {!roleCtx.hasAnyRole() && <Grid item xs={12}>
              <Typography variant="h6" color="error">
                <br />
                <span>You don't have any roles assigned for this site.</span>
                <br />
                <span>Please contact your Coca-Cola sponsor to request the correct level of access.</span>
              </Typography>
            </Grid>}
          </Grid>
        </Page>
  )
}